import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaButtonGroup from './VaButtonGroup.vue'

export const VaButtonGroup = withConfigTransport(_VaButtonGroup)
